// @flow weak

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as viewsActions from "../../../redux/reducers/views";
import Login from "./Login";
import { userActions } from "../../../redux/actions/user";

const mapStateToProps = state => {
  return {
    currentView: state.views.currentView,
    loginResponse: state.authentication
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...userActions
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/app/views/admin/login/index.js